module.exports = __webpack_public_path__ + "media/images/logo/ekuitas-buy-3bc4c929af93fe9c4e963d0a729ad50b.svg";